import type { WorkspaceEntityStore, WorkspaceRuntime } from '#layers/runtime/public';
import { createSpaceRoutes, validateWorkspaceSpaceRoutes } from '#layers/spaces/utils/routes';

export async function prepareWorkspaceSpaceRoutes({ store }: WorkspaceRuntime<WorkspaceEntityStore>) {
	const [spaces] = await Promise.all([
		store.MonospaceSpace.findMany({
			include: { sections: {} },
			fetchPolicy: 'fetch-only',
		}),
		store.MonospacePage.findMany({ fetchPolicy: 'fetch-only' }),
	]);

	const routes = createSpaceRoutes({ spaces });
	validateWorkspaceSpaceRoutes(routes);
	return routes;
}
